import { useTranslations } from '@vocab/react';
import { Box, Button, IconArrow } from 'braid-design-system';

import translations from './BottomNav.vocab';

interface BottomNavProps {
  onPrevious?: React.MouseEventHandler;
  onNext: React.MouseEventHandler;
}

export const BottomNav = ({ onPrevious, onNext }: BottomNavProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      display="flex"
      justifyContent="spaceBetween"
      alignItems="center"
      flexDirection="rowReverse"
    >
      <Box flexGrow={0} flexShrink={0}>
        <Button
          data={{ testid: 'continue-button' }}
          tone="formAccent"
          variant="solid"
          icon={<IconArrow direction="right" />}
          iconPosition="trailing"
          onClick={onNext}
        >
          {t('Continue')}
        </Button>
      </Box>
      {Boolean(onPrevious) && (
        <Button
          data={{ testid: 'back-button' }}
          onClick={onPrevious}
          icon={<IconArrow direction="left" />}
          bleed
          tone="formAccent"
          variant="transparent"
        >
          {t('Back')}
        </Button>
      )}
    </Box>
  );
};
